import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getPostsByPage } from "../../actions/posts"
import { getScores } from '../../actions/scores';

const GetPosts = () => {
    const user = JSON.parse(localStorage.getItem("profile"))
    const userId = user?.result?.googleId || user?.result?.userId
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getPostsByPage({ userId }));
        dispatch(getScores({ userId: userId, limitB: 25, limitU: 25 }))
    }, [])

    return (null)
}

export default GetPosts